import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { createGlobalStyle } from 'styled-components';

export interface SimpleModalGlobalStylesProps {
  closeTimeoutMS: number;
  contentClassNames: ReactModal.Classes;
  overlayClassNames: ReactModal.Classes;
}

const { spacing } = theme;

export const SimpleModalGlobalStyles = ({
  closeTimeoutMS,
  contentClassNames,
  overlayClassNames,
}: SimpleModalGlobalStylesProps) => createGlobalStyle`
  .${overlayClassNames.base} {
    position: fixed;
    display: grid;
    justify-content: center;
    align-content: center;
    z-index: 1000;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .${contentClassNames.base} {
    display: flex;
    flex-direction: column;
    margin: ${spacing.lg}px ${spacing.md}px;
    background: var(--neutral-white-base);
    border-radius: ${pxToRem(10)};
    box-shadow: 0 0 ${pxToRem(8)} ${pxToRem(3)} rgba(0, 0, 0, 0.2);
    transition: opacity ${closeTimeoutMS}ms ease ${closeTimeoutMS}ms;
    opacity: 0;
  }

  .${contentClassNames.afterOpen} {
    opacity: 1;
  }

  .${contentClassNames.beforeClose} {
    opacity: 0;
    transition-delay: 0s;
  }
`;
